define([], function (){

  let HEADER_END = 5;
  let TABLE_END = 6;
  let HEADER_START = 0;
  let TABLE_START = 1;
  let NUM_SHOWN = 6;
  let $COLUMN_HEADERS = $('.lesson-column');

  function init() {
    addRightArrow();
    hideExtraColumns();
    $('.left').hide();

    $('.right').on('click', function() {
      shiftRight();
    });

    $('.left').on('click', function() {
      shiftLeft();
    });
  }

  function addRightArrow(){
    let arrow = '<div class="right"><i class="fa fa-chevron-right"></i></div>';
    $COLUMN_HEADERS.eq(HEADER_END).append(arrow);
    $COLUMN_HEADERS.eq(HEADER_END).addClass('right-td');
  }

  function moveRightArrow(target){
    target.addClass('right-td');
    target.prev('td').removeClass('right-td');
    $('.right').appendTo(target);
  }

  function hideExtraColumns(){
    $('table tr').each(function(){
      $(this).find('td').slice(TABLE_END+1).each(function(){
        $(this).hide()
      });
    });
  }

  function shiftRight(){
    HEADER_END += 1;
    TABLE_END += 1;
    HEADER_START += 1;
    TABLE_START += 1;
    const $table_rows = $('table tr');
    moveRightArrow($COLUMN_HEADERS.eq(HEADER_END));

    $table_rows.each(function(){
      $(this).find('td').eq(TABLE_END).show()
    });

    $table_rows.each(function(){
      $(this).find('td').eq(TABLE_END-NUM_SHOWN).hide()
    });

    $('.left').show();

    if (TABLE_END >= $table_rows.eq(0).find('td').length-1){
      $('.right').hide();
    }
  }

  function shiftLeft(){
    const $table_rows = $('table tr');
    HEADER_END -= 1;
    TABLE_END -= 1;
    HEADER_START -= 1;
    TABLE_START -= 1;

    moveRightArrow($COLUMN_HEADERS.eq(HEADER_END));

    $table_rows.each(function(){

      $(this).find('td').eq(TABLE_END+1).hide()
    });

    $table_rows.each(function(){
      $(this).find('td').eq(TABLE_START).show()
    });
    $('.right').show();
    if (TABLE_START <= 1) {
      $('.left').hide();
    }
  }

  return {
    init: init
  }
});